import { PassDay } from '@domain/passes';

import { SupportedLanguages } from './constants.type';

export const CITY_TIMEZONE = '';
export const DEFAULT_CURRENCY: string = 'EUR';
export const MAX_SAFARI_CANVAS_SIZE = 16777216;
export const MAX_PNG_SIZE = 4000;
export const NG_LANGS_WITHOUT_SUPPORT = ['en', 'de', 'pt'];
export const DEFAULT_IBAN_FORMATTED = 'ES9121000418450200051332';
export const DEFAULT_IBAN_UNFORMATTED = 'es91 2100 0418 4502 0005 1332';
export const WEEK_DAYS: { id: PassDay; locale: string }[] = [
  {
    id: 'monday',
    locale: 'common:daysMondayText',
  },
  {
    id: 'tuesday',
    locale: 'common:daysTuesdayText',
  },
  {
    id: 'wednesday',
    locale: 'common:daysWednesdayText',
  },
  {
    id: 'thursday',
    locale: 'common:daysThursdayText',
  },
  {
    id: 'friday',
    locale: 'common:daysFridayText',
  },
  {
    id: 'saturday',
    locale: 'common:daysSaturdayText',
  },
  {
    id: 'sunday',
    locale: 'common:daysSundayText',
  },
];
export const PLACEHOLDER_IMAGE = 'https://images.xceed.me/static/entities/user-place-holder.jpg';
export const PLACEHOLDER_ARTIST_IMAGE = 'https://images.xceed.me/static/entities/artist-place-holder.jpg';
export const LANGAUAGE_PRIORITY: SupportedLanguages[] = ['en', 'es', 'it', 'fr', 'pt', 'de', 'ca'];
export const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const FILE_TYPE_CSV = 'csv';
export const FILE_TYPE_PDF = 'pdf';
export const FILE_TYPE_DOC = 'doc';
export const FILE_TYPE_JPG = 'jpg';
export const FILE_TYPE_JPEG = 'jpeg';
export const FILE_TYPE_PNG = 'png';
export const FILE_TYPE_WEBP = 'webp';
export const FILE_TYPE_AVIF = 'avif';
export const FILE_TYPE_MP4 = 'mp4';
export const FILE_TYPE_MOV = 'mov';
export const FILE_TYPE_WEBM = 'webm';
export const FILE_TYPE_EXCEL = 'xlsx';
export const SEPARATOR_TYPE_COMMA = 'comma';
export const SEPARATOR_TYPE_SEMICOLON = 'semicolon';
export const SORT_ASC = 'ASC';
export const SORT_DESC = 'DESC';
export const GENRE_MALE = 'male';
export const GENRE_FEMALE = 'female';
export const GENRE_NON_BINARY = 'non-binary';
export const GENRE_NOT_TO_SAY = 'not-to-say';
